<template>
  <div class="table-box">
    <div v-show="!showBox">
      <el-tabs
        v-if="!fromOrder && content.length > 1"
        v-model="activeName"
        @tab-click="tabClick"
      >
        <el-tab-pane
          :label="v.name"
          :name="v.name"
          v-for="(v, k) in content"
          :key="k"
        ></el-tab-pane>
      </el-tabs>
      <el-radio-group
        v-if="target.childMenu.length > 1"
        v-model="childActiveIndex"
        @change="handleChildClick"
        style="margin-bottom: 30px; display: block; text-align: left;"
      >
        <el-radio-button
          :label="k"
          :name="v.name"
          v-for="(v, k) in target.childMenu"
          :key="k"
        >
          {{ v.name }}
        </el-radio-button>
      </el-radio-group>
      <div v-show="!fromOrder" class="search-box">
        <l-search
          ref="search"
          :projectType="target.projectType"
          :searchItem="target.childMenu[childActiveIndex].search"
          @search="handleSearch"
          :searchCtrl="target.searchCtrl"
        />
      </div>
      <!-- 批量不通过-->
      <div
        class="size-reject"
        v-if="
          content[activeIndex].childMenu[childActiveIndex].name === '任务记录'
        "
      >
        <div
          style="flex:1;text-align:left;display: flex;align-items: center;"
          v-if="checkImage && imageIsRepeat"
        >
          <i
            class="el-icon-warning"
            style="color:red;font-size:18px;margin-right:5px;cursor: pointer;"
          ></i>
          <p style="margin-top: 3px;">
            图片查重提示：
            <span style="color:red;">*</span>
            标记任务记录内提交的图片存在重复，请注意查看
          </p>
        </div>
      </div>
      <!--列表-->
      <div>
        <el-table
          v-if="showForm"
          v-loading="loading"
          :data="tableData"
          border
          :empty-text="tips"
          style="width: 100%;"
          :stripe="true"
          :highlight-current-row="false"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            v-if="
              ![6].includes(content[activeIndex].projectType) &&
                this.content[this.activeIndex].childMenu[this.childActiveIndex]
                  .name === '任务记录'
            "
            :selectable="selectable"
            type="selection"
            width="55"
          ></el-table-column>
          <template v-for="(v, k) in tableHeader">
            <el-table-column v-if="v.type === 'expand'" :key="k" type="expand">
              <template slot-scope="{ row }">
                <tableFormOrder :data="{ row, column: v }" />
              </template>
            </el-table-column>
            <el-table-column
              v-else-if="v.type === 'index'"
              :key="k - 2"
              type="index"
              label="序号"
              align="center"
            />
            <!-- 新增根据接口动态渲染table-column -->
            <template v-else-if="v.customColumn">
              <myrender :key="k" :index="k" :render="v.render || null" />
            </template>
            <el-table-column
              v-else
              :prop="v.prop"
              :label="v.label"
              :formatter="v.formatter"
              :show-overflow-tooltip="true"
              :key="k"
              align="center"
            >
              <template slot-scope="scope">
                <myrender
                  v-if="v.render"
                  :row="scope.row"
                  :column="scope.column"
                  :index="k"
                  :render="v.render || null"
                />
                <div
                  v-else
                  :style="v.style && v.style(scope)"
                  class="cell el-tooltip"
                >
                  {{
                    v.formatter
                      ? v.formatter(
                          scope.row,
                          scope.column,
                          scope.row[scope.column.property]
                        )
                      : scope.row[scope.column.property] || '-'
                  }}
                </div>
              </template>
            </el-table-column>
          </template>
          <template
            v-if="
              content[activeIndex].childMenu[childActiveIndex].ctrl || showCtrl
            "
          >
            <el-table-column
              width="120"
              prop="province"
              label="操作"
              align="center"
              v-if="
                content[activeIndex].childMenu[childActiveIndex].name ===
                  '任务记录'
              "
            >
              <template slot-scope="scope">
                <el-button
                  v-if="
                    content[activeIndex].childMenu[childActiveIndex].ctrl &&
                      ![11, 12, 13, 14, 15].includes(
                        content[activeIndex].projectType
                      )
                  "
                  type="text"
                  size="small"
                  @click="showDetail(scope)"
                >
                  查看
                </el-button>
                <!-- 已通过(未提交甲方) 专区\市场准入无 -->
                <el-button
                  v-if="![6].includes(content[activeIndex].projectType)"
                  :disabled="
                    (scope.row.auditStatus ||
                      scope.row.audit_status ||
                      scope.row.authStatus) != 2
                  "
                  type="text"
                  size="small"
                  @click="taskNotPass(scope)"
                >
                  不通过
                </el-button>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <!--分页-->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="paginationData.pageNo"
          :total="totalElements"
          :page-size="paginationData.pageSize"
          layout="total, prev, pager, next, jumper"
          style="padding: 15px;"
        />
      </div>
    </div>
    <div class="component-box" v-if="showBox">
      <component v-if="showBox" :is="partName" :data="partDate"></component>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="60%"
      :before-close="handleClose"
    >
      <div slot="title"></div>
      <el-carousel
        trigger="click"
        height="45vh"
        :autoplay="false"
        :initial-index="carouselIndex"
        :indicator-position="'none'"
        :arrow="imagesList.length > 1 ? 'hover' : 'never'"
      >
        <el-carousel-item v-for="item in imagesList" :key="item">
          <div>
            <img class="show-modal" :src="item || '#'" alt />
          </div>
        </el-carousel-item>
      </el-carousel>
      <span slot="footer" class="dialog-footer"></span>
    </el-dialog>
  </div>
</template>

<script>
import createContent from './renderJS/index';
import myrender from './renderJS/myrender.js';
import surveyDetail from './child/surveyDetail';
import tableDetail from './child/tableDetail';
import formDetail from './child/formDetail';
import formAjaxDetail from './child/formAjaxDetail';
import makeSceneDetail from './child/makeSceneDetail';
import chatRecord from './child/chatRecord';
import medicaHistory from './child/medicaHistory';
import { company, aAlly } from '@/api/ajax';
import { pageInation } from '@/Mixin/listMixin';
import { makeSure } from '@/Mixin/makeSure';
import dicSelect from '@/components/Common/dicSelect.vue';
import gysAddEdit from './child/gys.vue';
import lSearch from './child/search.vue';
import digitDetail from './child/digitDetail.vue';
import tableFormOrder from './child/tableFormOrder';
import { projectTypeMap } from '@/config/staticData';

export default {
  name: 'assistant',
  mixins: [pageInation, makeSure],
  props: {
    // 项目税筹结构
    taxCollectionPattern: {
      type: Number,
      default: 0
    },
    // 项目类型
    projectType: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      methodCallback: function(res) {
        let name = res.name;
        if (this.activeName === '协定服务') {
          this.showCtrl = name == 2;
          this.searchQuery['fileupSource'] = name;
          this.searchQuery['projectType'] = 19;
        } else {
          this.showCtrl = false;
          this.searchQuery['fileupSource'] = name;
        }
        return res.list || res;
      },
      resetTableData: true,
      showCtrl: false,
      ajaxPart: null, // 当前接口集合
      target: null, // 当前选择数据集合
      fromOrder: false, // 是否从订单页面跳过来，是则不显示搜索条件
      fromOrderQuery: {}, // 从订单来的带有条件
      limitRule: [], // ？
      hideButton: false, // ?
      carouselIndex: 0, // 放大轮播当前指示器
      imagesList: [], // 放大轮播图片
      dialogVisible: false, // 轮播弹层
      tips: '请选择服务商和项目', // table无数据内容
      showBox: false, // false显示列表，true显示子组件(详情)
      activeName: '学术拜访', // 当前激活tab name
      activeIndex: 0, // 当前激活tab index
      childActiveIndex: 0, // 当前激活子
      content: null, // 内容集合
      getList: null, // 获取列表的AJAX
      searchQuery: {
        id: '', // 项目id
        enterprise_id: '',
        finish_dt: '',
        full_name: '',
        visit_address: '',
        audit_status: '',
        enterpriseName: '', //服务商
        projectName: '', // 项目名称
        taskDt: '', //任务月度
        auditStatus: '', //审核状态
        fullName: '', //项目参与人
        hospitalName: '', //医院名称
        taxCollectionPattern: 0 // 项目结构类型
      },
      partName: 'surveyDetail',
      partDate: { formData: {}, detailLimit: [] },
      // todo 搞到默认
      ajaxDetail: null,
      ajaxSearch: null,
      ajaxExportBtnText: null,
      ajaxExportSanBtnText: null,
      showForm: true,
      checkImage: false,
      selectedRows: []
    };
  },
  components: {
    dicSelect,
    gysAddEdit,
    lSearch,
    surveyDetail,
    formDetail,
    formAjaxDetail,
    tableDetail,
    myrender,
    chatRecord,
    medicaHistory,
    digitDetail,
    tableFormOrder,
    makeSceneDetail
  },
  filters: {},
  computed: {
    tableHeader() {
      //需要过滤的场景
      let blackList = [
        '学术拜访',
        '等级医院拜访',
        '基层医疗机构拜访',
        '数字拜访',
        '协定服务'
      ];
      let target =
        this.content[this.activeIndex].childMenu[this.childActiveIndex]
          .fields || [];
      if (blackList.includes(this.activeName)) {
        let use = +this.tableResp.name || 0;
        return target.filter(res => {
          if (!res.use) {
            return true;
          } else {
            return res.use.includes(use);
          }
        });
      } else {
        return target;
      }
    },
    imageIsRepeat() {
      if (!this.checkImage) {
        return false;
      }
      return (this.tableResp.remarkMap || {}).isExistRepeatPic == 1;
    }
  },
  watch: {
    '$route.query'(val, from) {
      if (from.detail && from.detail != '' && !val.detail) {
        this.showBox = false;
        delete this.partDate.formData;
      }
    }
  },
  methods: {
    // 可配置场景列表数据整理
    formatDataMethod(data) {
      let { list } = data;
      try {
        list.forEach(item => {
          let formatAnswer = [];
          let {
            makeSceneMap: { id, ...makeSceneMapOptions },
            topicList
          } = item;

          topicList.forEach(({ type, title, answer }) => {
            if (type === 13) {
              try {
                answer = JSON.parse(answer);
              } catch (e) {}
              formatAnswer.push({
                type,
                title,
                answer
              });
            }
          });
          Object.assign(item, makeSceneMapOptions, {
            formatAnswer
          });
        });
      } catch (e) {}
      return data;
    },
    // 选中条目
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    // 批量驳回
    rejectAll() {
      let planIdsArr = [];
      this.selectedRows.forEach(row => {
        planIdsArr.push(row.id);
      });
      let planIds = planIdsArr.join(',');
      let delEvent = planIds => {
        aAlly
          .taskNotPassAll({
            planIds,
            projectType: this.content[this.activeIndex].projectType
          })
          .then(res => {
            if (
              res.data.data.failIdListMessage &&
              res.data.data.failIdListMessage.length > 0
            ) {
              let msgArr = ['失败信息如下：'];
              let errArr = res.data.data.failIdListMessage;
              let errIds = res.data.data.failIdList;
              for (let i in errArr) {
                let index = planIdsArr.indexOf(+errIds[i]) + 1;
                msgArr.push(
                  `<span>[序号 ${index}] ${errArr[i].message}</span>`
                );
              }
              this.$alert(msgArr.join('<br/>'), res.data.message, {
                dangerouslyUseHTMLString: true
              });
            } else {
              this.$notify({
                title: '成功',
                message: res.data.message,
                type: 'success'
              });
              this.saveSuccess();
            }
          });
      };
      this.makeSureEvent(delEvent, planIds, '是否确定驳回选中记录？');
    },
    selectable(row, index) {
      let value = row.auditStatus || row.audit_status || row.authStatus;
      // 1 == 审核中 2=审核通过 3=审核不通过
      return value == 2;
    },
    taskNotPass(scope) {
      let delEvent = scope => {
        let { $index, row } = scope;
        aAlly
          .taskNotPass({
            planId: row.id,
            projectType: this.content[this.activeIndex].projectType
          })
          .then(res => {
            this.$notify({
              title: '成功',
              message: '操作成功',
              type: 'success'
            });
            this.saveSuccess();
          });
      };
      this.makeSureEvent(delEvent, scope);
    },
    partDateFilted() {
      let blackList = ['学术拜访', '等级医院拜访', '基层医疗机构拜访'];
      let limitlist = this.limitRule;
      let limit = [];
      if (blackList.includes(this.activeName)) {
        let use = +this.tableResp.name;
        if (use !== 0) {
          use = use || 1;
        }
        limit = limitlist.filter(res => {
          if (!res.use) {
            return true;
          } else {
            return res.use.includes(use);
          }
        });
        return limit;
      } else {
        return [...limitlist];
      }
    },
    handleClose() {
      this.dialogVisible = false;
      this.imagesList = [];
    },
    showImage(target, index, HideButton) {
      if (HideButton) {
        this.hideButton = true;
      }
      this.imagesList = target || [];
      this.dialogVisible = true;
      this.carouselIndex = index || 0;
      // console.log('将要选择的图片', target);
    },
    // 搜索参数是从search组件中接入
    handleSearch(e) {
      if (!this.ajaxPart) {
        throw new Error('无搜索接口！');
      }
      this.getList = this.ajaxPart.list;
      Object.keys(this.searchQuery).forEach(res => {
        if (res !== 'pageNo' || res !== 'pageSize') {
          this.$delete(this.searchQuery, res);
        }
      });
      Object.assign(this.searchQuery, e, {
        taxCollectionPattern: this.$route.meta.taxCollectionPattern
      });
      this.tips =
        this.childActiveIndex == 0 ? '暂无任务记录数据' : '暂无任务汇总数据';
      this.searchEvent();
    },
    handleDetail(target, data) {
      this.partName = target;
      this.partDate = data;
      this.$router.push({
        name: this.$route.name,
        query: { detail: +new Date() }
      });
      this.showBox = true;
    },
    hideDetail() {
      this.showBox = false;
      delete this.partDate.formData;
    },
    //处理页面内详情的逻辑
    showDetailAsyn(target, config, props) {
      this.partName = target.component;
      this.partDate = config;
      this.partProps = props || {};
      this.showBox = true;
    },
    closeDetail() {
      this.partName = null;
      this.partDate = [];
      this.showBox = false;
    },
    showDetail(scope) {
      console.log(this.partName);

      let { row, column } = scope;
      if (this.partName === 'digitDetail') {
        row.type = +this.tableResp.name || 1;
        this.handleDetail('digitDetail', { formData: row });
        return;
      }
      if (this.partName === 'formAjaxDetail') {
        // params.put("projectId", projectId);
        // params.put("visitPlanId", visitPlanId);
        // params.put("taxCollectionPattern"
        // TODO: 这是什么意思？ taxCollectionPattern: this.searchQuery.taxCollectionPattern;
      }
      // todo 这里要确认三个人的字段
      Object.assign(this.partDate, { formData: row });
      if (this.ajaxDetail) {
        let query = { id: row.id };
        if (this.partName === 'formAjaxDetail') {
          Object.assign(query, {
            taxCollectionPattern: this.searchQuery.taxCollectionPattern,
            visitPlanId: row.id
          });
        }
        if (this.partName == 'tableDetail') {
          let { saasUserId: userId, taskDt: month } = row;
          Object.assign(query, { ...row }, { userId, month });
        }
        this.ajaxDetail(query)
          .then(res => {
            switch (this.partName) {
              case 'surveyDetail':
                let list = res.data.data.list || res.data.data.topicList;
                Object.assign(this.partDate, { list });
                let map = res.data.data.makeSceneMap;
                if (map && typeof map === 'object') {
                  Object.assign(this.partDate.formData, map);
                }
                break;
              case 'makeSceneDetail':
                let makeSceneList = res.data.data;
                Object.assign(this.partDate, { makeSceneList });
                break;
              case 'tableDetail':
                let r = res.data.data;
                Object.assign(this.partDate, { ...r });
                break;
              case 'formAjaxDetail':
              case 'formDetail':
                let toMerge = {};
                if (
                  this.target.marked === 'otc1' ||
                  this.target.marked === 'ksh' ||
                  this.target.marked == 'hjh'
                ) {
                  toMerge = res.data.data[0];
                }
                let obj = Object.assign(
                  {},
                  { ...this.partDate.formData },
                  { ...toMerge }
                );
                let detailLimit = this.partDateFilted();
                delete this.partDate.detailLimit;
                Object.assign(
                  this.partDate,
                  { formData: obj },
                  { detailLimit }
                );
                break;
            }
            this.$router.push({
              name: this.$route.name,
              query: { detail: +new Date() }
            });
            this.showBox = true;
          })
          .catch(e => {
            console.error('出错了', e);
          });
      } else {
        let detailLimit = this.partDateFilted();
        delete this.partDate.detailLimit;
        this.partDate = Object.assign({}, this.partDate, { detailLimit });
        this.$router.push({
          name: this.$route.name,
          query: { detail: +new Date() }
        });
        setTimeout(() => {
          this.showBox = true;
        }, 1000);
      }
    },
    // 切换tab 对应接口与健全数据
    tabClick(tab) {
      this.searchQuery = {};
      if (typeof tab !== 'object' && +tab >= 0) {
        tab = { index: tab };
      } else {
        this.$nextTick(() => {
          this.$refs['search'].clear();
          let { taxCollectionPattern } = this.$route.meta;
          this.target.searchCtrl['taxCollectionPattern'] = taxCollectionPattern;
        });
      }
      const index = tab.index;
      this.activeIndex = index;
      this.target = this.content[index];
      this.tips = '请选择服务商和项目';
      this.setGetList(0);
    },
    handleChildClick(index) {
      this.showForm = false;
      this.setGetList(index);
      this.tips = '请选择服务商和项目';
      // this.totalElements = 0;
      this.childActiveIndex = index;
      this.getPageList(1);
      setTimeout(() => {
        this.showForm = true;
        if (this.fromOrder) {
          this.handleSearch(this.fromOrderQuery);
        }
      }, 30);
    },
    // 设置child对应数据 接口在此赋值
    setGetList(index = 0) {
      this.tableData = [];
      this.getList = null;
      this.childActiveIndex = index;
      let target = this.target.marked || 'xsbf';
      let ajaxPart = aAlly[target]['part' + index];
      let part = this.target.childMenu[index];
      this.ajaxPart = ajaxPart;
      // TODO: 需整理，搜索组件自己去做判断
      this.ajaxExport = part.ex ? ajaxPart.taskExport : null;
      this.ajaxExport2 = part.ex2 ? ajaxPart.taskExport2 : null;
      this.ajaxExport3 = part.ex3 ? ajaxPart.taskExport3 : null;
      this.ajaxExportBtnText = part.exportText || null;
      this.ajaxExportSanBtnText = part.export2Text || null;
      this.taskExportData = ajaxPart.taskExportData || null;
      this.checkImage = part.checkImage;
      if (part.ctrl) {
        this.limitRule = part.detailLimit;
        this.partDate = Object.assign({}, { detailLimit: part.detailLimit });
        this.partName = part.detailType;
        this.ajaxDetail = ajaxPart.detail || null;
      } else {
        this.partDate = {};
      }
    },
    changePage(nowPage) {
      this.page = nowPage;
      this.arr = [];
      this.getPageList(1);
    },
    defaultTime(value, type = 'month') {
      let date = new Date();
      if (value) {
        date = value;
      }
      let month = date.getMonth() + 1;
      let yearMonth = `${date.getFullYear()}-${
        month < 10 ? '0' + month : month
      }`;
      if (type == 'd') {
        const day = date.getDate();
        return `${yearMonth}-${day < 10 ? '0' + day : day}`;
      }
      return yearMonth;
    },
    // 初始化数据 taxCollectionPattern类型 1四级个人 2三级个人 3三级个体
    handleFromOrder() {
      // 三级与四级公用该组件，每次调用则初始化数据与条件
      Object.assign(this.$data, this.$options.data(), {
        content: this.getContentByProjectType() // 只展示一个内容
      });
      this.$nextTick(() => {
        this.$refs['search'].clear();
        let { taxCollectionPattern } = this.$route.meta;
        this.target.searchCtrl['taxCollectionPattern'] = taxCollectionPattern;
      });
      let query = this.$route.query;
      if (query.fromOrder) {
        this.fromOrder = true;

        let target = projectTypeMap[+query.type].assistantName;
        let index = this.content.findIndex(res => {
          return target === res.name;
        });
        console.log('跳转目标', index, target, this.content);
        if (index < 0) {
          index = 0;
        }
        this.tabClick(index);
        this.$nextTick(() => {
          ['enterpriseId', 'csoId', 'enterprise_id'].forEach(res => {
            query[res] = query.enterpriseId;
          });
          // 合并日期
          ['taskDt', 'task_dt', 'month'].forEach(res => {
            query[res] = query.taskDt || this.defaultTime();
          });
          // 合并企业id
          ['project_id'].forEach(res => {
            query[res] = query.projectId;
          });
          ['fullName'].forEach(res => {
            query[res] = query.name;
          });
          this.fromOrderQuery = query;
          console.log(query);
          this.handleSearch(query);
        });
      } else {
        this.fromOrder = false;
        this.tabClick({ index: 0 });
      }
    },
    /**
     * @description: 根据项目税筹结构与类型返回content内容
     * @return {array} 返回一个数组，只有一个元素(场景)
     */

    getContentByProjectType() {
      console.log(
        `当前税筹结构：${this.taxCollectionPattern}。 当前项目类型：${this.projectType}`
      );
      return [createContent(this.taxCollectionPattern)[this.projectType]];
    }
  },
  created() {
    this.searchQuery.taxCollectionPattern = this.taxCollectionPattern;
    this.handleFromOrder(this.taxCollectionPattern);
  }
};
</script>
<style lang="scss" scoped>
.el-table_img {
  max-height: 70px;
}

.size-reject {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

/*处理图片轮播内容*/
.el-carousel__item div {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  /*line-height: 150px;*/
  .show-modal {
    height: 45vh;
    width: auto;
  }

  margin: 0;
  /*background-color: #99a9bf;*/
}
</style>
